import { Component, OnInit, HostListener } from '@angular/core';
import {RecuperarPassComponent} from '../login/recuperar-pass/recuperar-pass.component';
import {MatDialog} from '@angular/material/dialog';
import {CrearComponent} from './crear/crear.component';
import { FormBuilder, Validators } from '@angular/forms';
import { AplicacionesService } from './aplicaciones.service';
import { TablesService } from '../generico/tables/tables.service';
import { AdministradorService } from '../administrador/administrador.service';
import { UsuarioAdminComponent } from '../administrador/usuario-admin/usuario-admin.component';

@Component({
  selector: 'app-aplicaciones',
  templateUrl: './aplicaciones.component.html',
  styleUrls: ['./aplicaciones.component.scss']
})
export class AplicacionesComponent implements OnInit {

  columns = ['id', 'nombre', 'estado', 'acciones'];
  recurso = 'gestionarApp';
  params = {};
  target : any;
  nombre_tabla = 'tabla-app';

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private app_ser : AplicacionesService,
    private tbserv : TablesService, 
    private admin_serv : AdministradorService
  ) { }

  ngOnInit(): void {
    this.target = document.querySelector('#btn_crear_apps');
    this.app_ser.consultar_aplicaciones();    
  }

  crearApp() {
    const dialogRef = this.dialog.open(CrearComponent, {
      width: '500px',
    });

    dialogRef.afterClosed()
            .subscribe(
              ()=>{
                this.app_ser.set_aplicacion(null);
                this.tbserv.tablas[this.nombre_tabla].cargar_datos(this.params);
              }
            );

  }

  @HostListener('Editar')
  editar_app(){

    let id_aplicacion = this.tbserv.params_event.id_aplicacion;
    this.app_ser
        .consultar_aplicacion(id_aplicacion)
        .then(()=>{
          
          let dialogRef = this.dialog.open(CrearComponent, {
            width: '500px',
          });

          dialogRef.afterClosed()
            .subscribe(
              ()=>{
                this.app_ser.set_aplicacion(null);
                this.tbserv.tablas[this.nombre_tabla].cargar_datos(this.params);
              }
            );

          this.app_ser.dialog_ref  = dialogRef;
        });
  }

  @HostListener('abrirTablaAdmin')
  abrirTablaAdmin(){
    this.admin_serv.id_aplicacion = this.tbserv.params_event.id_aplicacion;
    let dialogRef = this.dialog.open(UsuarioAdminComponent, {
      width: '800px',
    });

    this.admin_serv.tabla_adilogoRef = dialogRef;
  }


}
